import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ParserService {

  constructor(private http: HttpClient) { }

  getTraining(type:string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/parser/training/${type}`
      );
  }

  newTraining(type: string, content: string, language: string, category: string = null, cutoff: boolean = false): Observable<any> {
    let model: any = {
      type: type,
      content: content,
      language: language
    };

    if (category) {
      model.category = category;
      model.cutoff = cutoff;
    }

    return this.http
      .post(
        `/api/v1/admin/parser/training`,
        JSON.stringify(model)
      );
  }

  deleteTraining(type: string, id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/parser/training/${type}/${id}`
      );
  }

  boundary(content: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/parser/boundary`,
        { content: content }
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/parser.service.ts